const HOURS = Array.from({ length: 24 }, (_, i) => String(i).padStart(2, "0"));
const MINUTES = Array.from({ length: 60 }, (_, i) => String(i).padStart(2, "0"));

// 24-hour time picker (HH : MM) that looks the same on every device.
export const TimeField = ({ value, onChange, id, testid, className = "" }) => {
  const [h, m] = value ? value.slice(0, 5).split(":") : ["", ""];
  const sel = "min-h-[44px] flex-1 cursor-pointer appearance-none rounded-lg border border-slate-300 bg-white px-2 text-center text-sm text-[#0F172A] outline-none transition-colors hover:border-[#5C2D91] focus:border-[#5C2D91] focus:ring-1 focus:ring-[#5C2D91] sm:min-h-[40px]";
  return (
    <div className={`flex items-center gap-1 ${className}`} data-testid={testid}>
      <select id={id} aria-label="Hour" value={h} onChange={(e) => onChange(e.target.value ? `${e.target.value}:${m || "00"}` : "")} className={sel} data-testid={`${testid}-hour`}>
        <option value="">HH</option>
        {HOURS.map((x) => <option key={x} value={x}>{x}</option>)}
      </select>
      <span className="font-bold text-[#64748B]">:</span>
      <select aria-label="Minute" value={m} onChange={(e) => onChange(`${h || "00"}:${e.target.value || "00"}`)} className={sel} data-testid={`${testid}-minute`}>
        <option value="" disabled>MM</option>
        {MINUTES.map((x) => <option key={x} value={x}>{x}</option>)}
      </select>
    </div>
  );
};
